import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './InsInput.scss'
import { withTranslation } from 'react-i18next'

class InsInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPassword : false
    }
  }
  static propTypes = {
    name: PropTypes.string.isRequired,
    error: PropTypes.string,
    type: PropTypes.oneOf(['date', 'email', 'password', 'number', 'search', 'tel', 'text']),
  }

  static defaultProps = {
    type: 'text',
    country: 'FRANCE'
  }

  /**
   * Montrer/Cacher le mot de passe
   */
  showPassword() {
   this.setState({showPassword: !this.state.showPassword})
  }

  render() {
    const {
      t, 
      type,
      error, 
      name, 
      placeholder, 
      defaultValue, 
      onChange, 
      onBlur, 
      onInput,
      onFocus,
      disabled, 
      maxLength, 
      readOnly, 
      autoComplete = "new-password",
      value,
      country
    } = this.props
    let className = `ins_input ins_input_${type}${error ? ' error' : ''}`
    return (
      <div className={className+' mb20'}>
        <input 
          type={this.state.showPassword ? 'text' : type} 
          autoComplete={autoComplete}
          name={name}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={onChange}
          onBlur={onBlur}
          onInput={onInput}
          onFocus={onFocus}
          disabled={disabled}
          maxLength={maxLength}
          readOnly={readOnly}
          value={value}
        />
        {type === 'password' && 
          <div className='show_password' onClick={() => this.showPassword()}></div>
        }
        {error && 
          <div className={country === 'SPAIN' && name === 'retailer' ? 'error-'+name + ' error-custom-es' : 'error-'+name}>{t(error)}</div>
        }
      </div>
    )
  }
}

export default withTranslation()(InsInput)
